export enum ReconcileStatus {
  Reconciled = 'reconciled',
  Unreconciled = 'unreconciled',
}
